(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LastNameDialogController', LastNameDialogController);

    LastNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LastName'];

    function LastNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LastName) {
        var vm = this;
        vm.lastName = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:lastNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.lastName.id !== null) {
                LastName.update(vm.lastName, onSaveSuccess, onSaveError);
            } else {
                LastName.save(vm.lastName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
